import React, { useEffect, useState } from "react";
import Multistep from 'react-multistep'
import PhoneInput from "react-phone-number-input";
import {
    parsePhoneNumber,
    getCountryCallingCode,
    isValidPhoneNumber,
} from "react-phone-number-input";
import { useDispatch } from "react-redux";
import {SignupWithoutOtp} from "../../redux/actions/AuthAction"
import logolanding from "../../assets/logowhite.svg"
import Loader from "react-loader-spinner";
import landing1 from "../../assets/landing1.png";
import landing2 from "../../assets/landing2.png"
const IELTSLanding = () => {
    const dispatch = useDispatch();
    const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
    const [internationalNumber, setInternationalNumber] = useState("");
    const [disabledNumber, setDisabledNumber] = useState(false);
    const [callingCode, setCallingCode] = useState("");
    const [numberOremail, setNumberOrEmail] = useState("");
    const steps = [

        { name: 'StepOne', component: <StepOne /> },
        { name: 'StepTwo', component: <StepTwo /> },
        { name: 'StepThree', component: <StepThree /> },
        { name: 'StepFour', component: <StepFour /> }
    ];
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [city, setCity] = useState('');
    const [loder, setLoder] = useState(false);
    const [msg, setMsg] = useState("");
    const [errmsg, setErrmsg] = useState("");


    const prevStyle = { position: "absolute", padding: "10px", marginLeft: "35%", borderRadius: "10px", border: "none", marginTop: "10px" }
    const nextStyle = { position: "absolute", padding: "10px", borderRadius: "10px", border: "none", marginLeft: "45%", marginTop: "10px" }
    const prevStylemob = { position: "absolute", padding: "10px", marginLeft: "25%", borderRadius: "10px", border: "none", marginTop: "10px" }
    const nextStylemob = { position: "absolute", padding: "10px", borderRadius: "10px", border: "none", marginLeft: "45%", marginTop: "10px" }
    // const handleChange = (event) => {
    //     setValue(event.target.value);
    // };

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height,
        };
    }

    useEffect(() => {

        if (internationalNumber) {
            const userPhoneNumber = parsePhoneNumber(internationalNumber);

            if (userPhoneNumber) {
                if (isValidPhoneNumber(userPhoneNumber.number)) {
                    const country_calling_code = getCountryCallingCode(
                        userPhoneNumber.country
                    );

                    setCallingCode("+" + country_calling_code);
                    setNumberOrEmail(
                        internationalNumber.replace("+" + country_calling_code, "")
                    );
                }
            }
        }
    }, [internationalNumber]);
    console.log(numberOremail)

    const signupwithoutotp = (e) => {
        e.preventDefault();
        setLoder(true);
        console.log(name)
        console.log(email)
        console.log(city)
        console.log(numberOremail)
        if (!name || !email || !city || !numberOremail){
            console.log("Enter details")
            setLoder(false);
            setErrmsg("Please enter ")
        }
        else {
        const data = {
            name: name,
            phoneNumber: numberOremail,
            email: email,
            city: city,
            isWebsite: true,
            countryCode: callingCode,
            country: time_zone.country,
            timezone: time_zone.timezone,
            UTMSource:"ORGANIC_IELTS",
            // source: getDevice()
        };
        const onSucess = (res) => {
            // makeToast("success", msg);
            setLoder(false);
            console.log(res);
            setMsg("Details Submitted. We will get in touch with you soon.")
            

          

            

        };
        const onError = (res) => {
            //   setField("password");
            setLoder(false);
            // setErrmsg(res);
            // openSnackbar("Enter a valid number")

            console.log(res)
        };
        dispatch(SignupWithoutOtp(data, onSucess, onError));
    }
    };

    function StepOne() {
        return (
            <div className='d-flex justify-content-md-center'>
                <div className='justify-content-md-center'>
                    <label style={{ color: "white" }}>What is your name?</label>
                    <br></br>
                    <input
                        style={{ width: "300px" }}
                        className='form-control RegInput'
                        placeholder='Name'
                        type='text'
                        onChange={e => setName(e.target.value)}
                        value={name}
                        autoFocus
                        required
                    />
                </div>
            </div>
        )
    }
    function StepTwo() {
        return (
            <div className='d-flex justify-content-md-center'>
                <div className='justify-content-md-center'>
                    <label style={{ color: "white" }}>What is your mobile number?</label>
                    <PhoneInput
                        style={{ width: "300px" }}
                        className='form-control RegInput d-flex'
                        placeholder='Phone Number'
                        // type='text'
                        onChange={setInternationalNumber}
                        value={internationalNumber}
                        autoFocus
                        required
                        international
                        countryCallingCodeEditable={false}
                        defaultCountry={time_zone.country}
                    />
                </div>
            </div>
        )
    }
    function StepThree() {
        return (
            <div>
                <div className='d-flex justify-content-md-center'>
                    <div className='justify-content-md-center'>
                        <label style={{ color: "white" }}>What is your email?</label>
                        <input
                            style={{ width: "300px" }}
                            className='form-control RegInput'
                            placeholder='Email'
                            type='email'
                            onChange={e => setEmail(e.target.value)}
                            value={email}
                            autoFocus
                            required
                        />
                    </div>

                </div>
                
            </div>
        )
    }
    function StepFour() {
        return (
            <div>
            <div className='d-flex justify-content-md-center'>
                <div className='justify-content-md-center'>
                <label style={{ color: "white" }}>What is your city?</label>
                        <input
                            style={{ width: "300px" }}
                            className='form-control RegInput'
                            placeholder='City'
                            type='text'
                            onChange={e => setCity(e.target.value)}
                            value={city}
                            autoFocus
                            required
                        />
                </div>
            </div>
            <button onClick={signupwithoutotp} style={{position: "absolute", backgroundColor:"white", padding: "10px", borderRadius: "10px", border: "none", marginLeft: "45%", marginTop: "10px"}}>
                {loder? <Loader type="TailSpin" color="#00BFFF" height={20} width={40} />:msg?`Done`:"Submit"}
                </button>
                
            </div>
            
        )
    }
    return (
        <>
            <div className="ieltslanding">
                {getWindowDimensions().width <= 480 ?
                    <div className="form-container-mobile">
                        <div className="ml-4">
                            <img src={logolanding} alt="logo" width={"100px"} />
                        </div>
                        <h1 className="text-left ml-4">IELTS</h1>
                        <h3 className="text-left ml-4">Book a FREE CLASS with your mentor<br />
                            <span>Hurry! Limited Seats</span></h3>
                        <div className="mt-3" style={{marginLeft:"8%"}}>
                            <Multistep activeStep={0} showNavigation={true} steps={steps} prevStyle={prevStylemob} nextStyle={nextStylemob} />
                            <div className=" text-center pt-5 mt-5">{msg? <p style={{color:"white"}}>{msg}</p>:""}</div>
                            <div className="text-center" style={{color:"red", fontWeight:"bold"}}>{(errmsg && (!email || !name || !numberOremail || !city))? <p>{errmsg} {!name?"Name. ":""} {!email?"Email. ":""} {!numberOremail? "Correct Number. ":""} {!city?"City ":""}</p>:""}</div>
                        </div>
                        <div className="text-center mt-3">
                                <div className="mr-3">
                                    <img src={landing1} />
                                </div>
                               
                            </div>
                    </div>
                    :
                    <div className="d-flex">
                        <div className="content">
                            <div className="heading">
                            Become a person of <br/>value by mastering<br/> yourself to clear IELTS.
                            </div>
                            <p className="subheading mt-3">Live, one-on-one classes</p>
                            <p className="subheading">Access to Class Recordings</p>
                            <p className="subheading">Speaking and Writing Evaluation</p>
                            <div className="d-flex mt-5">
                                <div className="mr-3">
                                    <img src={landing1} />
                                </div>
                                <div>
                                    <img src={landing2} />
                                </div>
                            </div>
                        </div>
                        <div className="form-container ml-auto">
                            <div className="text-center">
                                <img src={logolanding} alt="logo" width={"300px"} />
                            </div>
                           
                            <h1 className="text-center ml-4">IELTS</h1>
                            <h3 className="text-center">Book a FREE CLASS with your mentor<br />
                                <span>Hurry! Limited Seats</span></h3>

                            <Multistep activeStep={0} showNavigation={true} steps={steps} prevStyle={prevStyle} nextStyle={nextStyle} />
                            <div className=" text-center pt-5 mt-5">{msg? <p style={{color:"white"}}>{msg}</p>:""}</div>
                            <div className="text-center" style={{color:"red", fontWeight:"bold"}}>{(errmsg && (!email || !name || !numberOremail || !city))? <p>{errmsg} {!name?"Name. ":""} {!email?"Email. ":""} {!numberOremail? "Correct Number. ":""} {!city?"City ":""}</p>:""}</div>
                        </div>
                    </div>
                }
            </div>
        </>
    );
};

export default IELTSLanding;